import { FieldSizes, Indicators } from "./constants.js";
// Stronger check on whether there is a current value
export var getHasInputValue = inputValue => {
  var _inputValue$length;
  return !!inputValue && ((_inputValue$length = inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) !== null && _inputValue$length !== void 0 ? _inputValue$length : 0) > 0;
};

/*
    React-select shows a string in the menu in all of the following cases: when
    the user is out of options, trying to add an option that's already been
    added, or if there weren't any options to begin with in the first place.
    It's used in a single prop, so we need logic on what string to show
    depending on the situation
  */
export var getCreatableNoOptionsMessage = function getCreatableNoOptionsMessage(inputValue, hasOptions) {
  var isCreatable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hasInputValue = getHasInputValue(inputValue);
  if (isCreatable) {
    /* Single or multi, and the user tries to type text they've already added
    via the menu or created */
    if (hasInputValue) return "\"".concat(inputValue, "\" already added");

    /* Single or multi, and the user focuses the text input, but there aren't
    any options to show so we don't show the menu until they start typing */
    if (!hasInputValue && !hasOptions) return null;

    /* Multi, and the user focuses the text input, but they've exhausted the menu
    options so we hint to them they can add their own */
    return 'Enter text to add more options';
  }

  // Multi, and the user has exhausted all menu options
  if (!hasInputValue && hasOptions) return 'All options added';

  // Single or multi, and no options to begin with
  if (!hasInputValue && !hasOptions) return 'No options';

  // Single or multi, and no filtered option returned
  return "\"".concat(inputValue, "\" not found");
};

/* Stronger check on options prop since react-select allows for a number of
types. */
export var getHasOptions = options => {
  var _options$length;
  return !!options && ((_options$length = options === null || options === void 0 ? void 0 : options.length) !== null && _options$length !== void 0 ? _options$length : 0) > 0;
};

// Determines size of icons in custom components
export var getIndicatorIconSize = (fieldSize, indicator) => {
  if (indicator === Indicators.CLEAR && fieldSize === FieldSizes.SMALL) return 14;
  if (indicator === Indicators.CLEAR && fieldSize === FieldSizes.MEDIUM) return 16;
  if (indicator === Indicators.CLEAR && fieldSize === FieldSizes.LARGE) return 18;
  if (indicator === Indicators.MULTI_VALUE_REMOVE) return 16;
  if (fieldSize === FieldSizes.SMALL) return 20;
  if (fieldSize === FieldSizes.LARGE) return 30;
  return 24;
};
export var getPlaceholderText = (isMulti, hasOptions, isCreatable) => {
  if (isCreatable && isMulti) return hasOptions ? 'Search or enter values' : 'Enter values';
  if (isCreatable) return hasOptions ? 'Search or enter value' : 'Enter a value';
  if (isMulti) return 'Search or select options';
  return 'Search or select option';
};